/**
 * Local cube-helper config for agent-homepage.
 * Decoupled from @loops-webv2/ui to avoid prod build failures.
 */

export interface CubeHelperConfig {
  REST: {
    cubejsCal: (options: { query: unknown; component: string; renewQuery?: boolean; version?: string }, pageType?: string) => Promise<unknown>;
    cubejsCalWithoutCache: (query: unknown) => Promise<{ data: { rows: unknown[] } }>;
  };
  util: {
    getGlobalCubeMeta: () => unknown[];
    removeValuesFromArray: (source: unknown[], valuesToRemoveArray: unknown[]) => unknown[];
    getFromStore: (key: string, isRaw: boolean) => unknown;
    getLoggedInUserRole: () => string | null;
    getLoggedInUserId: () => string | null;
    getRolePermissions: () => unknown;
  };
  ENDPOINT: {
    CUBEJS_URL: string;
    CUBEJS_CACHE_BYPASS: string;
  };
  COMPONENT: { HIERARCHICAL_QUERY: string };
}

let config: CubeHelperConfig | null = null;

export function setCubeHelperConfig(cfg: CubeHelperConfig): void {
  config = cfg;
}

export function getCubeHelperConfig(): CubeHelperConfig {
  if (!config) {
    throw new Error(
      'Cube helper config not set. Call setCubeHelperConfig({ REST, util, ENDPOINT, COMPONENT }) from your app before using cube-helper.'
    );
  }
  return config;
}
